import React, { useEffect, useState,useRef } from "react";
import { useLocation, useParams, useNavigate } from "react-router-dom";

import {
  useViewProductImagesQuery,
  useUpdateProductImagesMutation,
} from "../../../redux/services/productService/product.Services";

import {
  successToast,
  errorToast,
} from "../../../Utils/toast";

function UpdateProductImages() {
  const { id } = useParams();
    const fileInputRef = useRef(null);
  const navigate = useNavigate();
  // const dispatch = useDispatch();
  const {
    data,
    isLoading,
    isError,
  } = useViewProductImagesQuery(id, {
    skip: !id,
  });
    // const [imageRows, setImageRows] = useState([]);
  const [updateImages, { isLoading: isUpdating }] =
    useUpdateProductImagesMutation();
  const [images, setImages] = useState([]);
  useEffect(() => {
    if (data?.data) {
      setImages(data.data);
    }
  }, [data]);

  const handleTitleChange = (index, value) => {
    setImages((prev) =>
      prev.map((img, i) =>
        i === index
          ? { ...img, title: value }
          : img
      )
    );
  };
const handleImageSelect = (e) => {
  const files = Array.from(e.target.files);

  const newImages = files.map((file) => ({
    id: Date.now() + Math.random(),
    title: "",
    image_order: "",
    image: "",
    newImage: file,
    preview: URL.createObjectURL(file),
    isNew: true,
  }));

  setImages((prev) => [...prev, ...newImages]);

  e.target.value = "";
};
  const handleImageChange = (index, file) => {
    setImages((prev) =>
      prev.map((img, i) =>
        i === index
          ? {
            ...img,
            newImage: file,
            preview: URL.createObjectURL(file),
          }
          : img
      )
    );
  };
  const handleOrderChange = (index, value) => {
    setImages((prev) =>
      prev.map((img, i) =>
        i === index
          ? { ...img, image_order: value }
          : img
      )
    );
  };
  const handleSubmit = async () => {
    try {
      const formData = new FormData();
      formData.append("product_id", id);
      for (const img of images) {
        formData.append( "image_titles", img.title || "");
        formData.append("image_order",img.image_order || "" );
       if (img.newImage) {
        formData.append("images", img.newImage);
      } else {
        const res = await fetch(img.image);
        const blob = await res.blob();
        formData.append("images", blob, "old-image.jpg");
      }
      }
      const response =   await updateImages(formData).unwrap();
      successToast( response?.message ||
       "Images Updated Successfully"
      );
      navigate("/product-list");
    } catch (error) {
      errorToast(
        error?.data?.message ||
        error?.message ||
        "Update Failed"
      );
    }
  };
 const handleDeleteImage = (id) => {
  setImages((prev) => {
    const updated = prev.filter(
      (item) => item.id !== id
    );
    return updated;
  });
};
  if (isLoading) {
    return (
      <div className="text-center py-5">
        Loading Images...
      </div>
    );
  }

  if (isError) {
    return (
      <div className="alert alert-danger">
        Failed to load images
      </div>
    );
  }

  return (
    <div>

      <div className="page-header-breadcrumb all_breadcrumb">
        <div className="ms-md-1 mb-1 mb-md-0 ms-0 page_heading_breadcrumb">
          <nav>
            <h4 className="fw-semibold">
              Edit Images
            </h4>
            <ol className="breadcrumb mb-0">
              <li className="breadcrumb-item">
                <navigate to="/">
                  Home
                </navigate>
              </li>

              <li
                className="breadcrumb-item active"
                aria-current="page"
              >
                Edit Images
              </li>

            </ol>

          </nav>

        </div>
        <div className="page-title fw-semibold fs-18 mb-0">

          <button
            className="btn btn-primary me-2"
            onClick={() => navigate(-1)}
          >

            <span>
              <i className="fe fe-shopping-cart me-1"></i>
            </span>

            Product List

          </button>

              <button
                type="button"
                className="btn btn-lg btn-primary px-4 py-2"
                onClick={() => fileInputRef.current.click()}             
              >
               Add Image
              </button>

              <input
                ref={fileInputRef}
                type="file"
                hidden
                accept="image/*"
                multiple
                onChange={handleImageSelect}
              />
          

        </div>

      </div>



      <div className="st-wrapper-card">
        <div className="st-table-responsive">


          {images.length === 0 ? (
            <div className="alert alert-info">
              No Images Found
            </div>
          ) : (
            <div className="st-table-responsive">
              <table className="table st-custom-table align-middle mb-0">
                <thead className="">
                  <tr>
                    <th >#</th>
                    <th>Preview</th>
                    <th>Title</th>
                    <th>Order</th>
                    <th>Replace Image</th>
                    <th>Action</th>
                  </tr>
                </thead>

                <tbody>
                  {images.map((img, index) => (
                    <tr key={img.id}>
                      <td>{index + 1}</td>

                      <td>
                        <img
                          src={
                            img.preview
                              ? img.preview
                              : `http://localhost:5000/uploads/product/${img.image}`
                          }
                          alt={img.title}
                          style={{
                            width: "150px",
                            height: "100px",
                            objectFit: "cover",
                            borderRadius: "8px",
                            border: "1px solid #ddd",
                          }}
                        />
                      </td>

                      <td>
                        <input
                          type="text"
                          className="form-control"
                          value={img.title || ""}
                          onChange={(e) =>
                            handleTitleChange(
                              index,
                              e.target.value
                            )
                          }
                        />
                      </td>
                      <td>
                        <input
                          type="number"
                          className="form-control"
                          min="1"
                          value={img.image_order || ""}
                          onChange={(e) =>
                            handleOrderChange(
                              index,
                              e.target.value
                            )
                          }
                        />
                      </td>

                      <td>
                        <input
                          type="file"
                          className="form-control"
                          accept="image/*"
                          onChange={(e) =>
                            handleImageChange(
                              index,
                              e.target.files?.[0]
                            )
                          }

                        />

                      </td>
                      <td>
                        <button
                          type="button"
                          className="btn btn-danger btn-sm"
                          onClick={() =>
                            handleDeleteImage(img.id)
                          }
                        >
                          Delete
                        </button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}

          <div className="mt-4 text-end">
            <button
              className="btn btn-success px-4"
              onClick={handleSubmit}
              disabled={isUpdating}
            >
              {isUpdating
                ? "Updating..."
                : "Update Images"}
            </button>
          </div>
        </div>
      </div>

    </div>
  );
}

export default UpdateProductImages;